import React from "react";
import styles from "./mainSection.module.scss";

const MainSection = () => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container1}>
          <div className={styles.left}>
            <div className={styles.heading}>
              Your Whole Financial Life At Your Fingertips.
            </div>
            <div className={styles.text}>
              The UK's fastest growing financial super app has arrived in the
              U.S.
            </div>
            <div className={styles.text}>
              Exchange money with no hidden fees. Exchange, send and receive 28+
              currencies in seconds. Manage your money with spending analytics.
              Withdraw from 55,000+ surcharge-free ATMs nationwide. Join more
              than 15 million HOGI customers worldwide.
            </div>
          </div>
          <div className={styles.right}>
            <img className={styles.imgContainer} src={"/assets/main-section1.png"} />
            <img
              className={styles.imgContainerPhone}
              src={"/assets/main-section-phone1.png"}
            />
          </div>
        </div>
        <div className={styles.container2}>
          <div className={styles.left}>
            <div className={styles.heading}>Get More From Your Money</div>
            <div className={styles.text}>
              The UK's fastest growing financial super app has arrived in the
              U.S.
            </div>
            <div className={styles.text}>
              Exchange money with no hidden fees. Exchange, send and receive 28+
              currencies in seconds. Manage your money with spending analytics.
              Withdraw from 55,000+ nationwide. Join more than 15 million HOGI
              customers worldwide
            </div>
          </div>
          <div className={styles.right}>
            <img className={styles.imgContainer} src={"/assets/main-section2.png"} />
            <img
              className={styles.imgContainerPhone}
              src={"/assets/main-section-phone2.png"}
            />
          </div>
        </div>
        <div className={styles.container1}>
          <div className={styles.left}>
            <div className={styles.heading}>
              Send Money All Over The World Instantly, Without Hidden Fees
            </div>
            <div className={styles.text}>
              Exchange money with no hidden fees. Exchange, send and receive 28+
              currencies in seconds. Manage your money with spending analytics.
              Withdraw from 55,000. Join more than 15 million HOGI customers
              worldwide.
            </div>
          </div>
          <div className={styles.right}>
            <img className={styles.imgContainer} src={"/assets/main-section3.png"} />
            <img
              className={styles.imgContainerPhone}
              src={"/assets/main-section-phone3.png"}
            />
          </div>
        </div>
        <div className={styles.container2}>
          <div className={styles.left}>
            <div className={styles.heading}>
              Pay Like A Local Get The Market Exchange Rate
            </div>
            <div className={styles.text}>
              Spend abroad in over 150 currencies at the market exchange rates
              with no hidden fees. No fees on cash withdrawals abroad, up to
              $300 per month.
            </div>
          </div>
          <div className={styles.right}>
            <img className={styles.imgContainer} src={"/assets/main-section4.png"} />
            <img
              className={styles.imgContainerPhone}
              src={"/assets/main-section-phone4.png"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MainSection;
